import { genderOption, physicalDisability, traffickingSituation } from "./new-request-form";

export const availabilityByResponse: any = {
    yes: "Now",
    possible: "Now",
    possible_soon: "Soon",
    "3days": "Within 3 days",
    "7days": "Within 7 days",
    null: "No response",
    no: "Not available",
};
  
export const possibleResponses = Object.keys(availabilityByResponse);

const replaceGenderNameDic: any = {
    "Trans-female": "Trans female",
    "Trans-male": "Trans male",
};

export const responseTextByType: any = {
    yes: "We may have a bed available",
    possible: "We may have a bed available now",
    possible_soon: "We may have a bed available soon",
    no: "No available beds",
    "3days": "We may have a bed available in 3 days",
    "7days": "We may have a bed available in 7 days",
};

export const responseDisplayName: any = {
    yes: "Possible",
    possible: "Now",
    possible_soon: "Soon",
    no: "No",
    "3days": "Within 3 days",
    "7days": "Within 7 days",
    null: "Awaiting response",
    unknown: "-",
} as const;
  
export function replaceGenderName(originalName: string) {
    return replaceGenderNameDic[originalName] || originalName;
}
  
export function getOther(assessment: any, field: any) {
    if (assessment && assessment[field]) {
        const specialField = `${field}Special`;
        const assessmentField = Array.isArray(assessment[field])
        ? assessment[field]
        : [assessment[field]];

        const resultData = [
        ...assessmentField.filter(
            (it: any) => it != "Other" && it != "Additional information",
        ),
        ...(assessmentField.includes("Other")
            ? assessment[specialField]
            ? [`Other: ${assessment[specialField]}`]
            : ["Other"]
            : []),
        ...(assessmentField.includes("Additional information")
            ? assessment[specialField]
            ? [`Additional information: ${assessment[specialField]}`]
            : ["Additional information"]
            : []),
        ];

        const result =
        field === "genderId" ? resultData.map(replaceGenderName) : resultData;

        return result.join(", ");
    }
}

export const getElements = (value: string | string[] | null) => {
    if (Array.isArray(value)) return value.join(", ");
    return value;
};

export const cleanObject = (obj: any): any => {
    if (Array.isArray(obj)) {
      return obj
        .map((item) => cleanObject(item))
        .filter((item) => item !== null && item !== undefined);
    } else if (typeof obj === "object" && obj !== null) {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        if (key === "physicalDisability" && Array.isArray(value) && !value.includes(physicalDisability[physicalDisability.length - 1].value)) {
            // Remove 'physicalDisabilitySpecial' if 'Other' is not included
            delete acc["physicalDisabilitySpecial"];
        }
        if (key === "traffickingSituation" && Array.isArray(value) && !value.includes(traffickingSituation[traffickingSituation.length - 1].value)) {
            // Remove 'physicalDisabilitySpecial' if 'Other' is not included
            delete acc["physicalDisabilitySpecial"];
        }
        if (key === "accompanyingChildrenDetails" && Array.isArray(value)) {
            value.forEach((child: any, index: number) => {
              if (child.gender !== genderOption[genderOption.length - 1].value) {
                delete child.other; // Remove 'other' key if gender is not "Other"
              }
            });
        }

        const cleanedValue = cleanObject(value);
        if (cleanedValue !== "" && cleanedValue !== null && cleanedValue !== undefined) {
          acc[key] = cleanedValue;
        }
        return acc;
      }, {} as Record<string, any>);
    }
    return obj; // Return non-object values as is
};

export const isValidURL = (input: any) => {
    if (!input || typeof input !== "string") return false;
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return !!pattern.test(input);
};

export const formatUrl = (url: any) => {
    if (url && typeof url == "string") {
      return RegExp(/^https?:\/\//).test(url) ? url : `http://${url}`;
    }
    return url;
};

export const userRoleMap = {
  admin: "Safe Shelter Administrator",
  manager: "Manager",
  reviewer: "Safe Shelter User",
} as const;

export const needReasonOptions = [{
    label: "Confidentiality of shelter location was compromised",
    value: "Confidentiality of shelter location was compromised"
  }, {
    label: "No available beds accessible to persons with disabilities.",
    value: "No available beds accessible to persons with disabilities."
  }, {
    label: "No available beds for family or children",
    value: "No available beds for family or children"
  }, {
    label: "No available beds for men or boys",
    value: "No available beds for men or boys"
  }, {
    label: "No available beds in our shelter or nearby shelters",
    value: "No available beds in our shelter or nearby shelters"
  }, {
    label: "No available beds that allow pets",
    value: "No available beds that allow pets"
  }, {
    label: "No available beds that allow survivors struggling with substance",
    value: "No available beds that allow survivors struggling with substance"
  }, {
    label: "Public transportation unavailable at shelter location",
    value: "Public transportation unavailable at shelter location"
  }, {
    label: "Survivor is in a remote location /no shelter in area",
    value: "Survivor is in a remote location /no shelter in area"
  }, {
    label: "Other",
    value: "Other"
  }
];